<form [formGroup]="integranteFormGroup" class="principal-form">
  <div class="row">
    <h4 class="secondary-header">{{tituloIntegrante}}</h4>
  </div>

  <div class="row">
    <ng-container>
      <mat-form-field class="col-xs-6 col-sm-12">
        <mat-label>Rol</mat-label>
        <mat-select [formControl]="idRol" required (selectionChange)="onRolSelect($event)">
          <mat-option *ngFor="let rol of roles" [value]="rol.id">
            {{rol.nombre}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="idRol.invalid">
          Debe ingresar un rol
        </mat-error>
      </mat-form-field>
    </ng-container>
  </div>

  <div class="row">
    <mat-form-field class="col-xs-6 col-sm-12">
      <input matInput placeholder="Nombre:" [formControl]="nombreCompleto" required [disabled]="true">
      <mat-error *ngIf="nombreCompleto.invalid">
        Debe ingresar nombre
      </mat-error>
    </mat-form-field>
  </div>


  <div class="row" *ngIf="this.tipo_rol_id.value === 6">
    <mat-form-field class="col-xs-6 col-sm-12">
      <input matInput placeholder="Correo electrónico:" type="email" [formControl]="correo_electronico" required
        [disabled]="true">
      <mat-error *ngIf="correo_electronico.invalid">
        Debe ingresar un correo electrónico
      </mat-error>
    </mat-form-field>
  </div>

  <div class="documento">
    <!-- <form [formGroup]="documentoPersonaFormGroup"> -->
    <div class="row">
      <mat-form-field class="col-xs-12">
        <mat-label>País de documento:</mat-label>
        <mat-select [formControl]="pais_codigo" (selectionChange)="onChangePais($event)" required>
          <mat-option *ngFor="let pais of paises" [value]="pais.codigo">
            {{pais.nombre}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="pais_codigo.invalid">
          Debe ingresar país de documento
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row" *ngIf="tiposDocumentosFiltrado">
      <mat-form-field class="col-xs-6 col-sm-12">
        <mat-label>Documento:</mat-label>
        <mat-select [formControl]="tipo_documento_codigo" required>
          <mat-option *ngFor="let tipoDocumento of tiposDocumentosFiltrado" [value]="tipoDocumento.codigo">
            {{tipoDocumento.nombre}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="tipo_documento_codigo.invalid">
          Debe ingresar tipo documento
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="col-xs-6 col-sm-12">
        <input [type]="typeDoc" matInput [placeholder]="numberDoc" [formControl]="numero" required>
        <mat-error *ngIf="numero.invalid">
          Debe ingresar número válido
        </mat-error>
      </mat-form-field>
    </div>
    <!-- </form> -->
  </div>

  <!--<div *ngIf="needCertificadoNotarial" class="flex">
    <mat-form-field appearance="standard" class="full-width">
      <mat-label>Certificado notarial: *</mat-label>
      <ngx-mat-file-input [formControl]="certificado_notarial" accept=".pdf, .jpeg, .jpg, .png, .gif"
        (change)="onFileChange('certificado_notarial')" placeholder="Certificado notarial">
      </ngx-mat-file-input>
      <mat-icon matSuffix>
        <fa-icon icon="paperclip"></fa-icon>
      </mat-icon>
      <mat-hint align="end">
        <div class="flex" [matTooltip]="certificadoNotarialTooltip">
          <mat-icon>info</mat-icon>
          <span>Más información</span>
        </div>
      </mat-hint>
      <mat-hint align="end">Tamaño máximo 10 MB en formato .pdf, .jpeg, .jpg, .png o .gif</mat-hint>
      <mat-error>Debe ingresar un archivo con extensión .pdf, .jpeg, .jpg, .png o .gif, menor a 10 MB</mat-error>
    </mat-form-field>
  </div> -->

  <ng-container *ngIf="needAcreditacionRepresentacion">
    <mat-form-field appearance="standard" required>
      <mat-label>Acreditación de representación: *</mat-label>
      <ngx-mat-file-input [formControl]="acreditacion_representacion" accept=".pdf, .jpeg, .jpg, .png, .gif"
        (change)="onFileChange('acreditacion_representacion')" placeholder="Acreditación de representación">
      </ngx-mat-file-input>
      <mat-icon matSuffix>
        <fa-icon icon="paperclip"></fa-icon>
      </mat-icon>
      <mat-hint align="end">
        <div class="flex-tooltip">
          <mat-icon>info</mat-icon>
          <span>Mención en el certificado o carta poder. </span>
          <span>Tamaño máximo 10 MB en formato .pdf, .jpeg, .jpg, .png o .gif</span>
        </div>
      </mat-hint>
      <mat-error>
        <mat-icon>info</mat-icon>
        <span>Mención en el certificado o carta poder. </span>
        Debe ingresar un archivo con extensión .pdf, .jpeg, .jpg, .png o .gif, menor a 10 MB</mat-error>

    </mat-form-field>

  </ng-container>

  <!-- <rpe-check-list-form [formInput]="formCheckLab" (formValueChanges)="onLabChange($event)"
  (formStatusChanges)="onLabStatusChange($event)"></rpe-check-list-form> -->

  <ng-container *ngIf="isAnalista">
    <span>Seleccione al menos un laboratorio:</span>
    <div *ngFor="let laboratorio of laboratorios" class="lab-checkbox">
      <mat-checkbox (change)="onLabChange($event, laboratorio)">{{ laboratorio.nombre }}</mat-checkbox>
    </div>
  </ng-container>

  <div class="actions">
    <button mat-raised-button (click)="onCancelClick()">
      Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="addPersona()">
      Guardar
    </button>
  </div>
</form>